const asTrimmedString = (value) => String(value || '').trim();

const firstNonEmptyString = (values, fallback = '') => {
  for (const value of values) {
    const text = asTrimmedString(value);
    if (text) return text;
  }
  return asTrimmedString(fallback);
};

export const getPersonKey = (person) => firstNonEmptyString([
  person?.key,
  person?.userKey,
  person?.data_profile?.key,
]);

export const getPersonName = (person, fallback = '') => firstNonEmptyString([
  person?.data_profile?.name,
  person?.user?.name,
  person?.title,
  person?.name,
  person?.displayName,
  person?.email,
], fallback);

export const getPersonEmail = (person, fallback = '') => firstNonEmptyString([
  person?.data_profile?.email,
  person?.email,
], fallback);

export const getPersonPhoto = (person, fallback = '') => firstNonEmptyString([
  person?.data_profile?.photo,
  person?.photo,
], fallback);

export const getPersonCoverUrl = (person, fallback = '') => firstNonEmptyString([
  person?.coverUrl,
  person?.data_profile?.coverUrl,
], fallback);

export const buildPersonIdentity = (person, fallbackName = '') => ({
  key: getPersonKey(person),
  name: getPersonName(person, fallbackName),
  email: getPersonEmail(person),
  photo: getPersonPhoto(person),
  coverUrl: getPersonCoverUrl(person),
});
